import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Close, SaveChanges } from '../../../../constants';
import { ModalProps } from '../../../../types/UiKits';

/**
 * Only perform SweetAlert cleanup if SweetAlert classes/containers exist.
 * This avoids accidentally removing reactstrap modal backdrops when other
 * modals are still open.
 */
export function cleanupBodyLocks() {
  const html = document.documentElement;
  const body = document.body;

  const hasSwalClass =
    html.classList.contains('swal2-shown') || body.classList.contains('swal2-shown');
  const hasSwalContainer = !!document.querySelector('.swal2-container');

  if (!hasSwalClass && !hasSwalContainer) {
    // No SweetAlert artifacts present — do nothing.
    return;
  }

  // Remove SweetAlert classes and containers only.
  html.classList.remove('swal2-shown', 'swal2-height-auto');
  body.classList.remove('swal2-shown', 'swal2-no-backdrop', 'swal2-height-auto');
  document.querySelectorAll('.swal2-container').forEach((el) => el.remove());
}

const CommonModal: React.FC<ModalProps> = ({ modalData, children }) => {
  return (
    <Modal
      className={modalData.class}
      isOpen={modalData.isOpen}
      toggle={modalData.toggler}
      centered={modalData.center}
      size={modalData.size}
      onClosed={cleanupBodyLocks}
    >
      {modalData.header && <ModalHeader toggle={modalData.toggler}>{modalData.title}</ModalHeader>}
      <ModalBody className={modalData.bodyClass}>{children}</ModalBody>
      {modalData.footer && (
        <ModalFooter>
          <Button color="secondary" onClick={modalData.toggler}>
            {Close}
          </Button>
          <Button color="primary" onClick={modalData.toggler}>
            {modalData.button ? modalData.button : SaveChanges}
          </Button>
        </ModalFooter>
      )}
    </Modal>
  );
};
export default CommonModal;
